// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"11":"28d5c088","88":"6a3f71c9","229":"4f28cc9a","331":"808a4f83","438":"951b6699","483":"24368d36","521":"c2d666e0","561":"070890bc","685":"5ca350f4","695":"e3db90be","784":"b938c57c","878":"37dd662e","960":"b316fe27"}[chunkId] + ".chunk.js";
};